import { useTranslation } from 'react-i18next'

import Button from '../../../../../Button'
import { PageEmptyState } from '../../../../../PageEmptyState'
import Text from '../../../../../Text'
import { QA_NAME_LISTING_PROFILE_APPLICANTS_RETRY } from '../RentalPortalListingProfileApplicants.constants'

import RefreshIcon from '../../../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../../../icons/rental-portal.svg'

function ListingProfileApplicantsLoadError({ isLoading, onRetry }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={RentalPortalIcon}>
      <Text isSecondary>
        {t('RentalPortal.ListingProfileApplicantsLoadErrorKey')}
      </Text>
      <Button.Flat
        beforeIconProps={{ Icon: RefreshIcon }}
        isLoading={isLoading}
        qaName={QA_NAME_LISTING_PROFILE_APPLICANTS_RETRY}
        text={t('RentalPortal.ListingRetryBtnKey')}
        onClick={onRetry}
      />
    </PageEmptyState>
  )
}

export default ListingProfileApplicantsLoadError
